<template>
  <div>
    <empty-reminder v-show="records.length === 0 && !loading"></empty-reminder>

    <div>
      <div class="records" v-for="record in records">
        <p class="describe">{{ $t('user') }}{{ record.nickname }}{{ $t(record.status) }}</p>
        <p><span>{{ $t('time') }}: </span>{{ record.created_at | createFormatTime(record.created_at) }}</p>
      </div>
    </div>

    <spinner :show="loading" class="spinner-component"></spinner>
    <back-to-top></back-to-top>
    <load-more :current-page="currentPage" :total-page="totalPage" :loading="loading" @click.native="getRecords"></load-more>

  </div>
</template>

<script>
  import {createFormatTime} from 'src/lib/filters'
  import locales from './lang'
  import EmptyReminder from '../EmptyReminder.vue'
  import Spinner from '../../Spinner.vue'
  import BackToTop from '../../backToTop/BackToTop.vue'
  import LoadMore from '../../loadMore/LoadMore.vue'

  export default {
    name: 'friend-records',
    components: {EmptyReminder, Spinner, BackToTop, LoadMore},
    props: ['initFriendRecords'],
    data: function () {
      return {
        records: [],
        loading: false,
        currentPage: 0,
        totalPage: 1
      }
    },
    locales,
    watch: {
      initFriendRecords() {
        this.records = this.records.concat(this.initFriendRecords.data)
        this.totalPage = Math.ceil(this.initFriendRecords.meta['total'] / this.initFriendRecords.meta['per_page'])
        this.currentPage = this.initFriendRecords.meta['current_page']
      }
    },
    methods: {
      getRecords() {
        if (this.currentPage > this.totalPage) {
          return
        }
        this.loading = true
        this.currentPage++
        this.$http.get('api/invitation-records/commission', {params: {'page': this.currentPage}}).then(response => {
          this.loading = false
          this.records = this.records.concat(response.data.data)
          this.totalPage = Math.ceil(response.data.meta['total'] / response.data.meta['per_page'])
        }, response => {
          this.loading = false
        })
      }
    },
    filters: {createFormatTime}
  }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  @import "../../../assets/scss/variables";

  * {
    padding: 0;
    margin: 0;
  }

  .records {
    padding: .16rem 0;
    &:not(:last-child) {
      border-bottom: 1px solid #E0D7E3;
    }
  }

  p {
    font-size: .14rem;
    color: #333;
    letter-spacing: 0;
    line-height: .2rem;
    &:nth-child(n+2) {
      margin-top: .12rem;
      font-size: .12rem;
      color: #666;
      line-height: .18rem;
    }
  }

  .spinner-component {
    margin: 0 auto .1rem auto;
  }
</style>



// WEBPACK FOOTER //
// FriendRecordsM.vue?2c40af81